export const WarningTooltip = () => {
	return (
		<div data-svg-wrapper>
			<svg
				width="56"
				height="56"
				viewBox="0 0 56 56"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="4"
					y="4"
					width="48"
					height="48"
					rx="24"
					fill="#FEF0C7"
				/>
				<rect
					x="4"
					y="4"
					width="48"
					height="48"
					rx="24"
					stroke="#FFFAEB"
					strokeWidth="8"
				/>
				<path
					d="M28 25V29M28 33H28.01M26.29 19.86L17.82 34C17.6454 34.3024 17.553 34.6453 17.552 34.9945C17.551 35.3437 17.6415 35.6871 17.8144 35.9905C17.9874 36.2939 18.2367 36.5468 18.5377 36.7239C18.8387 36.901 19.1808 36.9962 19.53 37H36.47C36.8192 36.9962 37.1613 36.901 37.4623 36.7239C37.7633 36.5468 38.0126 36.2939 38.1856 35.9905C38.3585 35.6871 38.449 35.3437 38.448 34.9945C38.447 34.6453 38.3546 34.3024 38.18 34L29.71 19.86C29.5317 19.5661 29.2807 19.3231 28.9812 19.1545C28.6817 18.9859 28.3437 18.8973 28 18.8973C27.6563 18.8973 27.3183 18.9859 27.0188 19.1545C26.7193 19.3231 26.4683 19.5661 26.29 19.86Z"
					stroke="#DC6803"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
};
